import { IDEAS, IMG } from "../data/content";
import { PageHero, Reveal, Btn, useTitle } from "../components/shared";

export default function WeddingIdeas() {
  useTitle("Wedding Ideas | The Big Wedd — Inspiration Library");
  return (
    <main>
      <PageHero
        eyebrow="Wedding Ideas"
        title={[<span key="t">Explore wedding <span className="italic text-gold-light">ideas</span></span>]}
        sub="An inspiration library for every element of your celebration — fashion, decor, beauty, photography, entertainment and details."
        img={IMG.ideasHero}
      />

      <section className="bg-ivory py-24 md:py-32" data-testid="ideas-section">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {IDEAS.map((idea, i) => (
              <Reveal key={idea.title} delay={(i % 3) * 0.1}>
                <article className="group flex h-full flex-col border border-gold/25 bg-white/70 transition-all duration-500 hover:border-gold/60 hover:shadow-[0_20px_50px_rgba(197,160,89,0.15)]" data-testid={`idea-card-${i}`}>
                  <div className="relative overflow-hidden">
                    <img src={idea.img} alt={idea.title} loading="lazy" className="h-64 w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
                    <span className="absolute left-4 top-4 font-serif text-2xl italic text-ivory/90 drop-shadow">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div className="flex flex-1 flex-col p-6 md:p-7">
                    <h3 className="font-serif text-2xl md:text-[26px] text-emerald">{idea.title}</h3>
                    <div className="mt-4 flex flex-1 flex-wrap content-start gap-2">
                      {idea.items.map((it) => (
                        <span key={it} className="bg-sand px-3.5 py-1.5 text-[10px] uppercase tracking-[0.14em] text-stone2" data-testid={`idea-chip-${i}`}>
                          {it}
                        </span>
                      ))}
                    </div>
                    <p className="mt-5 border-t border-gold/20 pt-4 text-[10px] uppercase tracking-[0.2em] text-gold-text">
                      New ideas added continuously
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="mt-16 text-center">
            <p className="mx-auto max-w-xl text-sm italic leading-relaxed text-stone2">
              Save the ideas you love — then tell us. We'll design them into your celebration.
            </p>
            <div className="mt-8">
              <Btn to="/contact" testid="ideas-cta">Plan My Wedding</Btn>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
